import { useParams, Link } from 'react-router-dom';
import { SEO } from '@/components/feature/SEO';
import Breadcrumb from '@/components/feature/Breadcrumb';
import ComicCard from '@/components/feature/ComicCard';
import { getComicsByCategory, categories } from '@/mocks/comics';
import { useEffect, useState } from 'react';

export default function CategoryPage() {
  const { slug } = useParams<{ slug: string }>();
  const currentSlug = slug || 'all';
  const categoryInfo = categories.find((c) => c.slug === currentSlug);

  const [activeCategory, setActiveCategory] = useState(currentSlug);

  useEffect(() => {
    setActiveCategory(currentSlug);
    window.scrollTo({ top: 0, behavior: 'smooth' });
  }, [currentSlug]);

  const displayComics = getComicsByCategory(activeCategory);

  return (
    <>
      <SEO
        title={`${categoryInfo?.name || '全部'}漫画_高清韩国漫画_韩漫大全-韩漫网`}
        description={`韩漫网${categoryInfo?.name || '全部'}漫画分类，为您提供海量高清${categoryInfo?.name || ''}韩国漫画免费在线阅读，每日更新最新章节，尽享阅读乐趣。`}
        keywords={`${categoryInfo?.name || '全部'}漫画,高清韩国漫画,韩漫大全,免费韩漫在线阅读,韩漫网`}
        canonicalUrl={`https://www.hanmanwang.com/category/${currentSlug}`}
      />

      <main className="pt-16">
        <div className="w-full px-4 md:px-6 py-6 bg-background-50 border-b border-background-200/70">
          <Breadcrumb
            items={[
              { label: '首页', href: '/' },
              { label: '漫画分类', href: '/category/all' },
              { label: categoryInfo?.name || '全部' },
            ]}
          />
        </div>

        <section className="w-full px-4 md:px-6 py-8">
          <h1 className="text-2xl md:text-3xl font-heading font-bold text-foreground-900 mb-2">
            {categoryInfo?.name || '全部漫画'}
          </h1>
          <p className="text-sm text-foreground-500 mb-6">
            共 {displayComics.length} 部<strong>高清韩国漫画</strong>，海量<strong>韩漫大全</strong>尽在韩漫网
          </p>

          <div className="flex items-center gap-2 flex-wrap mb-8">
            {categories.map((cat) => (
              <Link
                key={cat.slug}
                to={`/category/${cat.slug}`}
                onClick={() => setActiveCategory(cat.slug)}
                className={`flex items-center gap-1.5 px-3 py-1.5 rounded-full text-sm transition-all duration-200 whitespace-nowrap cursor-pointer ${
                  activeCategory === cat.slug
                    ? 'bg-primary-500 text-background-50'
                    : 'bg-background-100 text-foreground-600 hover:bg-background-200 border border-background-200/70'
                }`}
              >
                <div className="w-3.5 h-3.5 flex items-center justify-center">
                  <i className={`${cat.icon} text-xs`}></i>
                </div>
                <span>{cat.name}</span>
              </Link>
            ))}
          </div>

          {displayComics.length > 0 ? (
            <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 xl:grid-cols-5 gap-4 md:gap-5" data-product-shop="">
              {displayComics.map((comic) => (
                <ComicCard key={comic.id} {...comic} />
              ))}
            </div>
          ) : (
            <div className="text-center py-20">
              <div className="w-16 h-16 flex items-center justify-center mx-auto mb-4">
                <i className="ri-book-2-line text-4xl text-foreground-300"></i>
              </div>
              <p className="text-foreground-500">该分类暂无漫画</p>
            </div>
          )}
        </section>
      </main>

      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{
          __html: JSON.stringify({
            "@context": "https://schema.org",
            "@type": "BreadcrumbList",
            itemListElement: [
              { "@type": "ListItem", position: 1, name: "首页", item: "https://www.hanmanwang.com/" },
              { "@type": "ListItem", position: 2, name: "漫画分类", item: "https://www.hanmanwang.com/category/all" },
              { "@type": "ListItem", position: 3, name: categoryInfo?.name || '全部' },
            ],
          }),
        }}
      />
    </>
  );
}